import {IGetRolesFilter} from "@models/roles/IGetRolesFilter.ts";
import {useApi} from "@contexts/hooks/api/useApi.ts";
import {IDataDto, IDataNoPageDto} from "@models/shared/IDataDto.ts";
import {RoleIncludable, RoleOrderable} from "@models/roles/roleTypes.ts";
import {IOrder} from "@models/shared/IOrder.ts";
import {__roles_endpoints} from "@components/roles/endpoints/__roles_endpoints.ts";
import {ICreateRoleDto} from "@models/roles/ICreateRoleDto.ts";
import {IChangeRoleMembro} from "@models/roles/IChangeRoleMembro.ts";
import {PermissaoAplicacao} from "@models/seguranca/permissaoApp.ts";
import {IDuplicaRoleDto} from "@components/roles/models/IDuplicaRoleDto.ts";

export function useRoles() {
    const {Get} = useApi()

    const getRole = (data: IDataNoPageDto<{ id: number }, RoleIncludable[] | undefined>) => {
        return Get(__roles_endpoints.v2['get-role'](data))
    }

    const getRoles = (data: IDataDto<IGetRolesFilter, RoleIncludable[] | undefined, IOrder<RoleOrderable>[] | undefined>) => {
        //@ts-ignore Não tem nada errado... mas ele acusa erro...
        return Get(__roles_endpoints.v2['get-roles'](data))
    }

    const createRole = (data: IDataDto<ICreateRoleDto>) => {
        return Get(__roles_endpoints.v2['create-role'](data))
    }
    const importRoles = (data: IDataDto<ICreateRoleDto[]>) => {
        return Get(__roles_endpoints.v2['import-roles'](data))
    }

    const addRoleMembro = (data: IDataNoPageDto<IChangeRoleMembro>) => {
        return Get(__roles_endpoints.v2['add-role-membro'](data))
    }
    const removeRoleMembro = (data: IDataNoPageDto<IChangeRoleMembro>) => {
        return Get(__roles_endpoints.v2['remove-role-membro'](data))
    }

    const getRolePermissoes = (data: IDataDto<{ roleId: number }>) => {
        return Get(__roles_endpoints.v2['get-permissoes'](data))
    }

    const addRolePermissao = (data: IDataNoPageDto<{ roleId: number, permissoes: PermissaoAplicacao[] }>) => {
        return Get(__roles_endpoints.v2['add-permissao'](data))
    }
    const removeRolePermissao = (data: IDataNoPageDto<{ roleId: number, permissoes: PermissaoAplicacao[] }>) => {
        return Get(__roles_endpoints.v2['remove-permissao'](data))
    }

    const duplicaRole = (data: { data: IDuplicaRoleDto }) => {
        return Get(__roles_endpoints.v2['duplica-role'](data))
    }

    return {
        getRole: getRole,
        getRoles: getRoles,
        createRole: createRole,
        importRoles: importRoles,
        addRoleMembro: addRoleMembro,
        removeRoleMembro: removeRoleMembro,
        getRolePermissoes: getRolePermissoes,
        addRolePermissao: addRolePermissao,
        removeRolePermissao: removeRolePermissao,
        duplicaRole: duplicaRole
    }
}